import { useAuthStore } from '../stores/authStore';

export default function DashboardPage() {
  const user = useAuthStore((s) => s.user);
  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold text-gray-900">工作台</h1>
      <div className="rounded-lg border-2 border-black p-6">
        <p className="text-base">
          当前社团：<span className="font-bold">{user?.tenant.name}</span>
        </p>
        <p className="mt-2 text-base">
          当前成员：<span className="font-bold">{user?.name}</span>（{user?.role}）
        </p>
      </div>
    </div>
  );
}
